import { UtensilsCrossed, Church, BookOpenText, Coffee, Trees, UsersRound, Blocks, HeartHandshake } from 'lucide-react'

// Single source of truth for event-type UI data.
export const EVENT_TYPES = {
  potluck:  { label: 'Potluck',      color: '#D97F4A', soft: '#FBEFE6', tint: '#FBEFE6', icon: UtensilsCrossed, sub: 'Dish coordination' },
  worship:  { label: 'Worship',      color: '#3B4CCA', soft: '#E8EAFB', tint: '#E8EAFB', icon: Church,          sub: 'Prayer · concert' },
  study:    { label: 'Bible Study',  color: '#C29A3D', soft: '#F7F0DC', tint: '#F7F0DC', icon: BookOpenText,    sub: 'Topic · scripture' },
  social:   { label: 'Social',       color: '#C75D8A', soft: '#F8E6EE', tint: '#F8E6EE', icon: Coffee,          sub: 'Casual gathering' },
  outdoors: { label: 'Outdoors',     color: '#5B8B6B', soft: '#E8F0EA', tint: '#E8F0EA', icon: Trees,           sub: 'Hike · sport · trail' },
  groups:   { label: 'Groups',       color: '#3FA0B5', soft: '#E0F0F3', tint: '#E0F0F3', icon: UsersRound,      sub: 'Small group · life group' },
  kids:     { label: 'Kids & Youth', color: '#C29A3D', soft: '#F7F0DC', tint: '#F7F0DC', icon: Blocks,          sub: 'VBS · camp · youth' },
  service:  { label: 'Service',      color: '#7C5CD3', soft: '#EFEAF8', tint: '#EFEAF8', icon: HeartHandshake,  sub: 'Volunteer outreach' },
} as const

export type EventTypeKey = keyof typeof EVENT_TYPES

export function getEventType(key: string) {
  return EVENT_TYPES[key as EventTypeKey] ?? EVENT_TYPES.potluck
}

export const EVENT_TYPE_IMAGES: Record<string, string> = {
  potluck:  'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=180&h=180&q=70',
  worship:  'https://images.unsplash.com/photo-1507692049790-de58290a4334?auto=format&fit=crop&w=180&h=180&q=70',
  study:    'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=180&h=180&q=70',
  social:   'https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=180&h=180&q=70',
  outdoors: 'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=180&h=180&q=70',
  groups:   'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=180&h=180&q=70',
  kids:     'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=180&h=180&q=70',
  service:  'https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=180&h=180&q=70',
}

export const GRADIENT = 'linear-gradient(135deg, #3B4CCA 0%, #7C5CD3 100%)'
